import React, { useState } from 'react'
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import OnioTabs from "../../Components/OnioTabs/index";

import { TabMenus } from './style'
import './index.css'

import StatusTab from './tabs/status'
import RoomTabe from './tabs/room'
import EnergTab from './tabs/energy'

const AnalyticsPage = () => {
  const [tab, setTab] = useState<number>(0);

  const handleTabClick = (ele: any, i: number) => {
    setTab(i)
  }
  const displayTabs = () => {
    switch (tab) {
      case 0:
        return (<StatusTab />)
      case 1:
        return (<RoomTabe />)
      case 2:
        return (<EnergTab />)
    }
  }
  return (
    <Container maxWidth="lg">
      <OnioTabs onClick={handleTabClick} menu={TabMenus} />
      {displayTabs()}
    </Container>
  )
}

export default AnalyticsPage